import React from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from "react-router-dom";
import FileUploader from "./components/FileUploader";
import FileTraining from "./components/FileTraining";
import Error404 from "./components/Error404"; // Una pantalla para mostrar el error 404
import LoadVideos from "./components/LoadVideos";
// Componente que valida si el ID es un UUID
const UploadRoute = () => {
  const { id } = useParams();

  // Regex para validar un UUID
  const isValidUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);

  if (!isValidUUID) {
    // Redirige a la página de error si el ID no es un UUID válido
    return <Navigate to="/error404" />;
  }

  return <FileUploader />;
};

const TrainRoute = () => {
  const { id } = useParams();

  // Regex para validar un UUID
  const isValidUUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(id);

  if (!isValidUUID) {
    // Redirige a la página de error si el ID no es un UUID válido
    return <Navigate to="/error404" />;
  }

  return <FileTraining/>;
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/upload/:id" element={<UploadRoute/>}/>
        <Route path="/training/:id" element={<TrainRoute/>} />
        <Route path="/videos/:id" element={<LoadVideos/>} />
        <Route path="/error404" element={<Error404 />} />
        <Route path="*" element={<Navigate to="/error404" />} /> {/* Ruta por defecto */}
      </Routes>
    </Router>
  );
};

export default App;
